import { Box, TextField } from '@mui/material';
import { useEffect, useState, useRef } from 'react';
import "../../App.css";
/**
 * Renders a component that allows the user to input a one-time password (OTP) by splitting it into individual digits.
 *
 * @param {Object} props - The component props.
 * @param {function} props.setCode - A callback function to set the OTP code. Preferably a useState setter function.
 *
 * @returns {JSX.Element} - The rendered OTPSplitDigitInput component.
 *
 * @throws {Error} - If an error occurs during the rendering of the component.
 */
export const OTPSplitDigitInput = ({ code, setCode }) => {
  const [codeDigits, setCodeDigits] = useState(['', '', '', '', '', '']);
  const inputRef = useRef(null);

  const handleCodeChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 6) {
      const newCodes = value.split('').concat(Array(6 - value.length).fill(''));
      setCodeDigits(newCodes);
      setCode(value);
    }
  };

  useEffect(() => {
    if (code !== '') {
      setCodeDigits(code.split('').concat(Array(6 - code.length).fill('')));
    } else {
      setCodeDigits(['', '', '', '', '', '']);
    }
  }, [code]);

  const handleCodeKeyDown = (e) => {
    if (e.key === 'Backspace' && codeDigits[0] === '') {
      setCode('');
      inputRef.current.focus();
    }
  };

  return (
    <TextField
      inputRef={inputRef}
      id="code-input"
      variant="outlined"
      margin="normal"
      value={codeDigits.join('')}
      autoComplete="off"
      onChange={handleCodeChange}
      onKeyDown={handleCodeKeyDown}
      inputProps={{
        sx: {
          width: { xs: '250px', sm: '300px' },
          height: { xs: '50px', sm: '60px' },
          p: 2,
          boxSizing: 'border-box',
        },
      }}
    sx={{
      '& .MuiOutlinedInput-root': {
        fontWeight: 500,
        fontSize: '16px',
        borderRadius: '10px',
        color: 'var(--aimdFlowSecondaryDarkTextColor)',
        width: '100%', 
        backgroundColor: '#fff',

        '& fieldset': {
          borderColor: 'var(--aimdFlowPrimaryColor)',
          borderWidth: '1px',
          borderRadius: '10px', 
        },
    
        '&:hover fieldset': {
          borderColor: 'var(--aimdFlowPrimaryColor)',
          borderWidth: '1px',
        },
    
        '&.Mui-focused': {
          '& fieldset': {
            borderColor: 'var(--aimdFlowPrimaryColor)',
            borderWidth: '2px',
          },
          '& input': {
            backgroundColor: '#fff', 
            color: 'var(--aimdFlowSecondaryDarkTextColor)',
            width: '100%', 
            padding: '10px', 
            borderRadius: '10px',
          },
        },
      },
    }}
      type="tel"
    />
  );
};
